import React from "react";

const Logo = ({ style }) => {
  const logoSrc =
    process.env.REACT_APP_COMPANY === "provesta"
      ? "/Logo_H.png"
      : "/logo_cca.png";
  return (
    <a href="/" class="flex">
      <img
        src={logoSrc}
        class="h-10 mr-3"
        alt="CCA Logo - Provesta"
        style={style}
      />
    </a>
  );
};

export default Logo;
